export const drvImportFile = {
    namespaced: true,

    state: {
        importType: 0
    },

    getters: {
        getImportType(state) {
            return state.importType;
        }
    },

    mutations: {
        setImportType(state, data) {
            state.importType = data;
        }
    }
};

export default drvImportFile;
